import { DropDown } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { Constants } from "../../../types/constants";

export const PreferredEmailLangContent = ({
  preferredEmailsLangMsgRef,
  notificationPreferences,
  onChange,
}) => {
  const { t, i18n } = useTranslation(["Preferences"]);

  return (
    <div className="m-4 d-flex justify-content-between align-items-center">
      <div className="fw-600 col-3">
        {t("NotificationPreferences.PreferEmailsLangTitle")}
      </div>
      <div className="notification-content col-9">
        <div className="m-3 d-flex align-items-center gap-3">
          <div>{t("NotificationPreferences.PreferEmailsLangMsg")}</div>
          <div>
            <DropDown
              ref={preferredEmailsLangMsgRef}
              value={notificationPreferences?.PreferredEmailLanguage}
              dataSource={[
                {
                  text: t("English"),
                  value: Constants.EmailLangPreference.English,
                },
                {
                  text: t("Spanish"),
                  value: Constants.EmailLangPreference.Spanish,
                },
              ]}
              fields={{
                text: "text",
                value: "value",
              }}
              htmlFor="notification-preffered-lang-value"
              id="notification-preffered-lang-value"
              locale={i18n.language}
              change={onChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
